import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const avatarClasses = tv({
  base: [
    "Avatar__root",
    "inline-flex",
    "items-center",
    "justify-center",
    "overflow-hidden",
    "rounded-full",
    "bg-gray-100",
    "align-middle",
    "text-base",
    "font-medium",
    "text-black",
    "select-none",
  ],
  variants: {
    variant: {
      circle: ["rounded-full"],
      square: ["rounded-none"],
      rounded: ["rounded-md"],
    },
    size: {
      small: ["size-8"],
      medium: ["size-12"],
      large: ["size-14"],
    },
  },
});

export const avatarImageClasses = tv({
  base: ["Avatar__image size-full object-cover"],
  variants: {
    variant: {
      circle: ["rounded-full"],
      square: ["rounded-none"],
      rounded: ["rounded-2xl"],
    },
  },
});

export type AvatarVariants = VariantProps<typeof avatarClasses>;
